import React from "react";
import { motion, Variants } from "framer-motion";
import { useTranslation } from "react-i18next";
import cls from "./BooksSection.module.css";
import Section from "../components/Section";

// Импорт всех 10 обложек
import tom1 from "../assets/10/tom_1.jpeg";
import tom2 from "../assets/10/tom_2.jpeg";
import tom3 from "../assets/10/tom_3.jpeg";
import tom4 from "../assets/10/tom_4.jpeg";
import tom5 from "../assets/10/tom_5.jpeg";
import tom6 from "../assets/10/tom_6.jpeg";
import tom7 from "../assets/10/tom_7.jpeg";
import tom8 from "../assets/10/tom_8.jpeg";
import tom9 from "../assets/10/tom_9.jpeg";
import tom10 from "../assets/10/tom_10.jpeg";

interface BooksSectionProps {
  isActive: boolean;
}

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.3,
    },
  },
};

const bookVariants: Variants = {
  hidden: { opacity: 0, y: 50, scale: 0.9 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 12,
    },
  },
};

const BooksSection: React.FC<BooksSectionProps> = ({ isActive }) => {
  const { t } = useTranslation();

  // Массив данных: тут прописываем разные ссылки для каждого тома
  const booksData = [
    { id: 1, img: tom1, link: "https://satbayev.university/upload/base/downloads/path/kitap/10%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA/1%20%D1%82%D0%BE%D0%BC%20%D2%9A%D0%B0%D0%B7%D0%B0%D2%9B%D1%81%D1%82%D0%B0%D0%BD%D0%BD%D1%8B%D2%A3%20%D1%82%D0%B0%D0%B1%D0%B8%D2%93%D0%B8%20%D0%B1%D0%B0%D0%B9%D0%BB%D1%8B%D2%9B%D1%82%D0%B0%D1%80%D1%8B%20%D0%B6%D3%99%D0%BD%D0%B5%20%D2%93%D1%8B%D0%BB%D1%8B%D0%BC%D1%8B.pdf" },
    { id: 2, img: tom2, link: "https://satbayev.university/upload/base/downloads/path/kitap/10%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA/2%20%D1%82%D0%BE%D0%BC%20%D0%91%D0%BE%D0%BB%D1%8C%D1%88%D0%BE%D0%B9%20%D0%96%D0%B5%D0%B7%D0%BA%D0%B0%D0%B7%D0%B3%D0%B0%D0%BD.pdf" },
    { id: 3, img: tom3, link: "https://satbayev.university/upload/base/downloads/path/kitap/10%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA/3%20%D1%82%D0%BE%D0%BC%20%D0%9C%D0%B8%D0%BD%D0%B5%D1%80%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B5%20%D1%80%D0%B5%D1%81%D1%83%D1%80%D1%81%D1%8B%20%D0%9A%D0%B0%D0%B7%D0%B0%D1%85%D1%81%D1%82%D0%B0%D0%BD%D0%B0%20%D1%87%D0%B5%D1%80%D0%BD%D1%8B%D0%B5%20%D0%BC%D0%B5%D1%82%D0%B0%D0%BB%D0%BB%D1%8B.pdf" },
    { id: 4, img: tom4, link: "https://satbayev.university/upload/base/downloads/path/kitap/10%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA/4%20%D1%82%D0%BE%D0%BC%20%D0%9C%D0%B8%D0%BD%D0%B5%D1%80%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B5%20%D1%80%D0%B5%D1%81%D1%83%D1%80%D1%81%D1%8B%20%D0%9A%D0%B0%D0%B7%D0%B0%D1%85%D1%81%D1%82%D0%B0%D0%BD%D0%B0%20%D1%86%D0%B2%D0%B5%D1%82%D0%BD%D1%8B%D0%B5%20%D0%BC%D0%B5%D1%82%D0%B0%D0%BB%D0%BB%D1%8B.pdf" },
    { id: 5, img: tom5, link: "https://satbayev.university/upload/base/downloads/path/kitap/10%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA/5%20%D1%82%D0%BE%D0%BC%20%D0%93%D0%B5%D0%BE%D0%BB%D0%BE%D0%B3%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B5%20%D0%B8%D0%B7%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%9A%D0%B0%D0%B7%D0%B0%D1%85%D1%81%D1%82%D0%B0%D0%BD%D0%B0.%D0%9C%D0%B5%D1%82%D0%B0%D0%BB%D0%BB%D0%BE%D0%B3%D0%B5%D0%BD%D0%B8%D1%8F.pdf" },
    { id: 6, img: tom6, link: "https://satbayev.university/upload/base/downloads/path/kitap/10%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA/6%20%D1%82%D0%BE%D0%BC%20%D0%9D%D0%B0%D1%83%D0%BA%D0%B0%20%D0%9A%D0%B0%D0%B7%D0%B0%D1%85%D1%81%D1%82%D0%B0%D0%BD%D0%B0%201941-1951%D0%B3%D0%B3.pdf" },
    { id: 7, img: tom7, link: "https://satbayev.university/upload/base/downloads/path/kitap/10%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA/7%20%D1%82%D0%BE%D0%BC%20%D0%9D%D0%B0%D1%83%D0%BA%D0%B0%20%D0%9A%D0%B0%D0%B7%D0%B0%D1%85%D1%81%D1%82%D0%B0%D0%BD%D0%B0%201955-1963%D0%B3%D0%B3.pdf" },
    { id: 8, img: tom8, link: "https://satbayev.university/upload/base/downloads/path/kitap/10%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA/8%20%D1%82%D0%BE%D0%BC%20%D0%9D%D0%B0%D1%83%D1%87%D0%BD%D0%BE-%20%D0%BF%D0%BE%D0%BF%D1%83%D0%BB%D1%8F%D1%80%D0%BD%D1%8B%D0%B5%20%D0%B8%20%D0%BE%D0%B1%D1%89%D0%B5%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BD%D0%BE-%20%D0%BF%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%B8%D0%B5%20%D1%81%D1%82%D0%B0%D1%82%D1%8C%D0%B8%2C%20%D0%B2%D1%8B%D1%81%D1%82%D1%83%D0%BF%D0%BB%D0%B5%D0%BD%D0%B8%D1%8F.pdf" },
    { id: 9, img: tom9, link: "https://satbayev.university/upload/base/downloads/path/kitap/10%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA/9%20%D1%82%D0%BE%D0%BC%20%D0%9F%D1%83%D0%B1%D0%BB%D0%B8%D1%86%D0%B8%D1%81%D1%82%D0%B8%D0%BA%D0%B0.%20%D0%9C%D0%B0%D1%82%D0%B5%D1%80%D0%B8%D0%B0%D0%BB%D1%8B%20%D0%BA%20%D0%B1%D0%B8%D0%B1%D0%BB%D0%B8%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%BD%D0%B8.pdf" },
    { id: 10, img: tom10, link: "https://satbayev.university/upload/base/downloads/path/kitap/10%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA/10%20%D1%82%D0%BE%D0%BC%20%D0%90%D0%BB%D0%B3%D0%B5%D0%B1%D1%80%D0%B0.pdf" },
  ];

  return (
    <Section isActive={isActive}>
      <div className={cls.spiritSection}>
        <div className={cls.container}>
          
          <motion.h2 
            className={cls.title}
            initial={{ opacity: 0, y: -20 }}
            animate={isActive ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            {t("books.mainTitle")}
          </motion.h2>

          <motion.div 
            className={cls.booksBlock}
            variants={containerVariants}
            initial="hidden"
            animate={isActive ? "visible" : "hidden"}
          >
            {booksData.map((book) => (
              <motion.div 
                key={book.id} 
                className={cls.bookItem}
                variants={bookVariants}
                whileHover={{ y: -10 }}
              >
                <img 
                  className={cls.bookImg} 
                  src={book.img} 
                  alt={`${book.id} ${t("books.volume")}`} 
                />
                <a 
                  href={book.link} 
                  className={cls.bookBtn}
                  target="_blank"        // Новое окно
                  rel="noopener noreferrer" 
                >
                  {book.id} {t("books.volume")}
                </a>
              </motion.div>
            ))}
          </motion.div>

        </div>
      </div>
    </Section>
  );
};

export default BooksSection;